import React from "react"
import { usePage } from "@inertiajs/react"
import translate from "@/utils/translate"

export default function PoweredBy() {
    const { permission_override } = usePage().props;
    const showPoweredBy = permission_override?.show_powered_by === true;

    if (!showPoweredBy) {
        return null;
    }

    return (
        <div className="cs_auth_footer">
            <div className="cs_auth_footer_container">
                <a 
                    href="https://apexcapital.com/" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="apex-footer-badge"
                >
                    <div className="apex-logo-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 459.82 464.76">
                            <polygon 
                                fill="#6132f6" 
                                points="174.47 0 282.9 0 459.82 464.76 349.63 464.76 228.92 147.19 152.77 352.49 286.14 352.49 138.07 464.76 0 464.76 174.47 0"
                            />
                        </svg>
                    </div>
                    <div className="apex-footer-text">
                        Powered by <span className="apex-footer-text-bold">{translate("Apex Capital Ventures")}</span> — {translate("Apex One Builder System")}
                    </div>
                </a>
            </div>
        </div>
    )
}